var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3D9AE2"
    },
    d: "M387.545,115.24v370.461c0,14.525-11.774,26.298-26.298,26.298H56.111 c-14.525,0-26.298-11.774-26.298-26.298V115.24c0-14.525,11.774-26.298,26.298-26.298h305.136 C375.772,88.942,387.545,100.716,387.545,115.24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5AAAE7"
    },
    d: "M387.545,115.24v362.498H85.182c-14.525,0-26.298-11.773-26.298-26.298V88.942h302.364 C375.772,88.942,387.545,100.716,387.545,115.24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96C8EF"
    },
    d: "M463.513,405.997l-291.992,88.561c-13.902,4.215-28.582-3.634-32.798-17.525L31.194,122.508 c-4.226-13.892,3.623-28.582,17.525-32.798l5.679-1.723L340.711,1.139c13.902-4.215,28.582,3.634,32.798,17.536l105.1,346.478 l2.44,8.046C485.263,387.091,477.414,401.782,463.513,405.997z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C2DFF6"
    },
    d: "M478.608,365.153L192.285,451.99c-13.902,4.215-28.582-3.634-32.798-17.525L54.398,87.987 L340.711,1.139c13.902-4.215,28.582,3.634,32.798,17.536L478.608,365.153z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3D9AE2"
    },
    d: "M219.765,177.405c11.798,0.766,17.589,1.529,20.288,10.429c2.322,7.654-0.578,12.427-9.125,15.019 c-7.948,2.411-11.815,0.154-15.229-1.84c-2.287-1.335-4.879-2.849-8.12-1.866c-4.944,1.499-7.212,7.828-5.864,12.273 c2.211,7.291,13.478,11.901,25.819,10.878l0.942,3.103c1.563,5.151,7.024,8.07,12.175,6.508c5.151-1.563,8.07-7.024,6.508-12.175 l-1.004-3.31c12.144-7.29,16.499-19.846,11.949-34.845c-6.583-21.702-23.992-22.738-34.393-23.356l-1.216-0.071 c-10.338-0.596-14.986-1.116-16.831-7.196c-1.026-3.383-0.566-5.834,1.491-7.951c2.153-2.218,5.513-3.565,7.952-4.306 c5.895-1.788,9.603-1.11,12.309-0.616c1.925,0.352,3.744,0.685,5.726,0.084c5.574-1.691,6.934-8.308,5.742-12.236 c-2.536-8.361-15.286-7.499-22.115-6.387l-0.949-3.13c-1.563-5.151-7.024-8.07-12.174-6.509c-5.151,1.563-8.07,7.024-6.508,12.175 l1.304,4.299c-10.871,7.15-14.716,18.009-10.828,30.83C193.215,175.679,207.937,176.635,219.765,177.405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3D9AE2"
    },
    d: "M377.748,222.445c-1.249-4.116-5.6-6.438-9.712-5.191l-221.975,67.331 c-4.115,1.249-6.439,5.597-5.191,9.712c1.02,3.362,4.108,5.529,7.448,5.529c0.749,0,1.511-0.109,2.263-0.337l221.975-67.331 C376.672,230.909,378.995,226.56,377.748,222.445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3D9AE2"
    },
    d: "M390.708,265.173c-1.249-4.116-5.598-6.437-9.712-5.191l-221.975,67.33 c-4.115,1.249-6.439,5.597-5.191,9.712c1.02,3.362,4.108,5.529,7.448,5.529c0.749,0,1.511-0.109,2.263-0.337l221.975-67.331 C389.631,273.636,391.956,269.288,390.708,265.173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3D9AE2"
    },
    d: "M403.668,307.9c-1.249-4.115-5.6-6.438-9.712-5.191L171.982,370.04 c-4.115,1.249-6.439,5.597-5.191,9.712c1.02,3.362,4.108,5.529,7.448,5.529c0.749,0,1.511-0.109,2.263-0.337l221.975-67.331 C402.592,316.363,404.917,312.015,403.668,307.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3D9AE2"
    },
    d: "M416.629,350.628c-1.249-4.116-5.598-6.437-9.712-5.191l-221.975,67.331 c-4.115,1.249-6.439,5.597-5.191,9.712c1.02,3.362,4.108,5.529,7.448,5.529c0.749,0,1.511-0.109,2.263-0.337l221.975-67.331 C415.553,359.091,417.877,354.742,416.629,350.628z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E81CE"
    },
    d: "M151.483,58.543l-14.909,4.516c-4.62-13.736-17.619-23.651-32.891-23.651 c-19.135,0-34.698,15.563-34.698,34.698v90.015c0,11.182,9.105,20.287,20.287,20.287s20.287-9.105,20.287-20.287V74.303 c0-1.017-0.239-1.983-0.685-2.834c-1.028-2.025-3.135-3.416-5.565-3.416c-3.447,0-6.25,2.803-6.25,6.25v77.255 c0,4.298-3.488,7.787-7.787,7.787s-7.787-3.488-7.787-7.787V74.303c0-12.033,9.791-21.824,21.824-21.824 c9.448,0,17.505,6.032,20.536,14.442c0.831,2.305,1.287,4.797,1.287,7.382v89.817c0,19.768-16.093,35.86-35.86,35.86 c-19.778,0-35.86-16.093-35.86-35.86V74.106c0-27.721,22.55-50.271,50.271-50.271C125.974,23.835,144.921,38.422,151.483,58.543z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBill);
export default __webpack_public_path__ + "static/media/bill.ebef19c2946255ff7b22ec819633aeec.svg";
export { ForwardRef as ReactComponent };